import type { CmsData } from '@packages/cms-components/interfaces/webapp_json';
import { ComponentTypes } from '@packages/cms-components/interfaces/components';
import { Container } from '@packages/shared';
import { Html, ModalByTextlink } from '@packages/cms-components';
import type { FooterBlockType } from './types';

type SocketProps = {
  data: CmsData;
};

export enum SocketTestIds {
  main = 'socket',
  noRenderComponentFound = 'socket-no-component-found',
}

const AreaSocket = ({ data }: SocketProps): JSX.Element => {
  const comp = (data.paragraph as FooterBlockType[])
    ?.filter((item) => item.parent_field_name === 'field_socket')
    ?.map((item, index) => {
      const keyModalByTextlink = `socket-${ComponentTypes.TextlinkModal}-${index}`;
      const keyHtml = `socket-${ComponentTypes.Html}-${index}`;
      if (item.type === ComponentTypes.TextlinkModal) {
        return <ModalByTextlink key={keyModalByTextlink} data={item} />;
      }

      if (item.type === ComponentTypes.Html) {
        return <Html key={keyHtml} data={item} />;
      }

      return <div />;
    });

  if (data && comp.length > 0) {
    return (
      <Container
        sx={({ spacing }) => ({
          color: 'text.dark',
          typography: ['body2', null, 'body3'],
          padding: [spacing(3, 2, 9, 2), null, spacing(3, 0, 9, 0)],
          '& p': {
            margin: 0,
            p: 0,
            '+ p': {
              pt: [1.5, 1.5, 1],
            },
          },
          '& a': {
            color: 'text.dark',
            textDecoration: 'none',
          },
        })}
      >
        {comp}
      </Container>
    );
  }

  return <div data-testid={SocketTestIds.noRenderComponentFound} />;
};

// eslint-disable-next-line import/no-default-export
export default AreaSocket;
